import { Component, OnInit } from '@angular/core';
import { NormatividadService } from 'src/app/servicios/normatividad.service';
import { Loading } from 'src/app/Class/Loading';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sub-menu-norma-externa',
  templateUrl: './sub-menu-norma-externa.component.html',
  styleUrls: ['./sub-menu-norma-externa.component.css']
})
export class SubMenuNormaExternaComponent implements OnInit {
  public normas: any = [];
  public success: any;

  constructor(private normatividadService: NormatividadService, public loading: Loading, private route: Router) {
   
    this.loading.estado = true;
    
      this.normatividadService.getListadoNormaExterna()
      .subscribe( data => {
          this.normas = data['normas'];        
          this.loading.estado = false;
      });
  }

  ngOnInit() {
  }

  

}
